export const Strings = {
  paySuccess: 'Your payment has been successful!',
  payFail: 'Payment Failed !',
  authFail: 'Authentication Failed',
  payCancel: 'Payment processing cancelled by user',
  success: 'success',
  fail: 'fail',
  loading: 'loading',
  alreadyPaid: 'Your Payment is Already done',
  serverError: 'Something Went Wrong, Try Again!',
}
